<template>
  <div class="margin-subpages micro-learning-modal">
    <div>
      <div class="fs-18 fw-700 upppercase">{{ $t("sparks.custom_sparks") }}</div>
      <div class="line-max-width my-16 mb-24"></div>
      <div class="grid-4-25">
        <div class="flex-mid">
          <div
            class="create-set center fs-18 fw-900 cursor-pointer"
            @click.prevent="dialogCreateSetStatus = !dialogCreateSetStatus"
          >
            + {{ $t("sparks.Create_a_Set") }}
          </div>
        </div>
        <div
          class="flex-mid"
          style="height: 132px"
          v-for="(set, index) in customList"
          :key="index + set.name"
        >
          <div
            class="set-spark cursor-pointer"
            @click.prevent="showSetCard(set)"
          >
            <div class="card three custom" v-if="set.cardList.length > 2"></div>
            <div class="card two custom" v-if="set.cardList.length > 1"></div>
            <div class="card one custom">
              <div class="fs-16 fw-700 ellipsis">{{ set.name }}</div>
              <div class="mt-4 flex">
                <div class="card-permissions ellipsis mr-3">
                  {{ set.permissions[0] }}
                </div>
                <div v-if="set.permissions.length > 1" class="card-permissions">
                  + {{ set.permissions.length - 1 }}
                </div>
              </div>
              <div class="flex fs-12 mt-16">
                <div class="ellipsis" style="width: 100px">
                  {{ setNumber(set.happilySet, set.customSet) }}
                </div>
                <div class="ml-auto">
                  {{
                    set.cardList.length === 1
                      ? "1 card"
                      : set.cardList.length + " cards"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="fs-18 fw-700 upppercase mt-40">{{ $t("sparks.HAPPILY_S_SPARKS") }}</div>
      <div class="line-max-width my-16"></div>
      <div v-if="sparkHappilyloading" class="grid-4-25">
        <div class="flex-mid" style="height: 132px">
          <div class="set-spark">
            <div class="card two happily text-skeleton">
              <div> </div>
            </div>
            <div class="card one happily text-skeleton">
              <div> </div>
            </div>
          </div>
        </div>
        <div class="flex-mid" style="height: 132px">
          <div class="set-spark">
            <div class="card one happily text-skeleton">
              <div> </div>
            </div>
          </div>
        </div>
        <div class="flex-mid" style="height: 132px">
          <div class="set-spark">
            <div class="card one happily text-skeleton">
              <div> </div>
            </div>
          </div>
        </div>
      </div>
      <draggable
        v-model="setShowingList"
        class="grid-4-25"
        v-bind="dragOptions"
        :move="chooseRecipe"
        @update="updateSet"
      >
        <div
          v-for="set in setShowingList"
          :key="set.id"
          class="flex-mid"
          style="height: 132px"
        >
          <div
            class="set-spark cursor-pointer"
            @click.prevent="showSetCard(set)"
          >
            <div
              class="card three"
              :class="{
                happily: set.type === 'happily',
                custom: set.type === 'custom',
              }"
              v-if="set.cardList.length > 2"
            ></div>
            <div
              class="card two"
              v-if="set.cardList.length > 1"
              :class="{
                happily: set.type === 'happily',
                custom: set.type === 'custom',
              }"
            ></div>
            <div
              class="card one"
              :class="{
                happily: set.type === 'happily',
                custom: set.type === 'custom',
              }"
            >
              <div class="fs-16 fw-700 ellipsis">{{ set.name }}</div>
              <div class="mt-4 flex">
                <div class="card-permissions ellipsis mr-3">
                  {{ set.permissions[0] }}
                </div>
                <div v-if="set.permissions.length > 1" class="card-permissions">
                  + {{ set.permissions.length - 1 }}
                </div>
              </div>
              <div class="flex fs-12 mt-16">
                <div
                  v-if="set.type === 'happily'"
                  class="ellipsis"
                  style="width: 100px"
                >
                  {{ $t("sparks.Set") }} {{ set.happilySet }}
                </div>
                <div
                  v-else-if="set.type === 'custom'"
                  class="ellipsis"
                  style="width: 100px"
                >
                  {{ setNumber(set.happilySet, set.customSet) }}
                </div>
                <div class="ml-auto">
                  {{
                    set.cardList.length === 1
                      ? "1 card"
                      : set.cardList.length + " cards"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <div class="remove-padding-modal">
      <el-dialog
        :visible.sync="dialogCreateSetStatus"
        top="8vh"
        width="930px"
        :before-close="clearCreateNewSet"
      >
        <div class="grid-2-create-set">
          <div class="my-32 px-40">
            <div class="fs-18 fw-900 mb-40 mb-8">
              {{ editSetStatus ? newSet.setName : "New Spark Set" }}
            </div>
            <div class="bg-F8F8F8 px-20 pt-24 pb-20">
              <div class="fs-16 fw-700 mt-12 mb-8">{{ $t("sparks.Name_of_Spark_Set") }}</div>
              <el-input
                :placeholder="$t('sparks.Set_name')"
                v-model="newSet.setName"
                :class="{ 'validate-input': validateNewSet.setName }"
              ></el-input>
              <div v-if="validateNewSet.setName" class="validate-worming">
                <div class="text">{{ $t("sparks.Please_input_Set_Name") }}</div>
              </div>
              <div class="fs-16 fw-700 mt-12 mb-8">{{ $t("sparks.Display_After") }}</div>
              <el-select
                v-model="newSet.position"
                :placeholder="$t('sparks.Select')"
                class="width-select"
              >
                <el-option
                  key="#beforeSetOne"
                  label="Before Set 1"
                  value="#beforeSetOne"
                >
                </el-option>
                <el-option
                  v-for="set in setShowingList"
                  :key="set.id"
                  :label="showLableNewSet(set)"
                  :value="set.id"
                >
                </el-option>
              </el-select>
              <div class="fs-16 fw-700 mt-12 mb-8">{{ $t("sparks.Audience") }}</div>
              <el-input
                :placeholder="$t('sparks.Set_name')"
                v-model="newSet.permissions"
                disabled
                :class="{ 'validate-input': validateNewSet.permissions }"
              ></el-input>
              <div v-if="editSetStatus">
                <div class="mt-32 mb-12">
                  <el-button
                    class="btn-add"
                    style="padding: 16px 29px; margin-left: auto"
                    @click.prevent="saveChangesSet"
                    >{{ $t("sparks.SAVE_CHANGES") }}</el-button
                  >
                  <el-button
                    class="btn-gray"
                    style="padding: 16px 24px"
                    @click.prevent="clearCreateNewSet"
                    >{{ $t("sparks.CANCEL") }}</el-button
                  >
                </div>
                <el-button
                  class="btn-red"
                  style="padding: 16px 32px; width: 100%"
                  @click.prevent="deleteSparkSet"
                  >{{ $t("sparks.DELETE_SPARK_SET") }}</el-button
                >
              </div>
              <div v-else class="mt-32">
                <el-button
                  class="btn-add"
                  style="padding-left: 32px; padding-right: 32px"
                  @click.prevent="createNewSet"
                  >{{ $t("sparks.CREATE_SET") }}</el-button
                >
                <el-button
                  class="btn-gray"
                  style="padding-left: 32px; padding-right: 32px"
                  @click.prevent="clearCreateNewSet"
                  >{{ $t("sparks.CANCEL") }}</el-button
                >
              </div>
            </div>
          </div>
          <div class="bg-F8F8F8 p-40 flex-mid" style="height: 850px">
            <div>
              <div class="set-spark-mock" style="z-index: 1">
                <div class="card card-mock three happily"></div>
                <div class="card card-mock two happily"></div>
                <div class="card card-mock one happily"></div>
              </div>
              <div class="flex-mid">
                <div class="line-llink-new-set"></div>
              </div>
              <div class="set-spark-mock" style="z-index: 1">
                <div class="card card-mock three custom"></div>
                <div class="card card-mock two custom"></div>
                <div class="card card-mock one custom">
                  <div class="skeleton-title"></div>
                  <div class="skeleton-content"></div>
                </div>
              </div>
              <div class="flex-mid">
                <div class="line-llink-new-set"></div>
              </div>
              <div class="set-spark-mock">
                <div class="card card-mock three happily"></div>
                <div class="card card-mock two happily"></div>
                <div class="card card-mock one happily"></div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogEditSetStatus"
        top="8vh"
        width="930px"
        :before-close="clossEditSet"
      >
        <div class="grid-2-create-set">
          <div class="my-32 px-40">
            <div class="fs-18 fw-900 mb-8">
              {{ setSelectedForEdit.setName }}
            </div>
            <div class="mb-30">
              <span
                v-if="setSelectedForEdit.type == 'custom'"
                @click.prevent="editSet(setSelectedForEdit)"
                class="edit-text cursor-pointer"
              >
                {{ $t("sparks.Edit") }}
                <i class="el-icon-edit"></i>
              </span>
            </div>
            <div>
              <div class="flex-center">
                <div class="card-permissions ellipsis mr-12">
                  {{ setSelectedForEdit.permissions[0] }}
                </div>
                <div
                  v-if="setSelectedForEdit.permissions.length > 1"
                  class="card-permissions mr-12"
                >
                  + {{ setSelectedForEdit.permissions.length - 1 }}
                </div>
                <div
                  class="mt-2 fs-12 opa-07 ellipsis"
                  style="max-width: 90px"
                  v-if="setSelectedForEdit.type == 'custom'"
                >
                  {{
                    setNumber(
                      setSelectedForEdit.happilySet,
                      setSelectedForEdit.customSet
                    )
                  }}
                </div>
                <div
                  class="mt-2 fs-12 opa-07 ellipsis"
                  style="max-width: 90px"
                  v-else
                >
                  Set {{ setSelectedForEdit.happilySet }}
                </div>
                <div class="ml-auto mt-2 fs-12 opa-07">
                  {{
                    setSelectedForEdit.cardList.length === 1
                      ? "1 card"
                      : setSelectedForEdit.cardList.length + " cards"
                  }}
                </div>
              </div>
            </div>
            <draggable
              v-model="setSelectedForEdit.cardList"
              v-bind="dragOptions"
              class="px-6"
              :move="chooseRecipeCard"
              @update="updateCradList"
            >
              <div
                v-for="(card, index) in setSelectedForEdit.cardList"
                :key="card.id"
                class="card-list flex-center px-24 mt-15 cursor-pointer"
                :class="{ 'card-selected': card.id == editCardOfSet.id }"
                @click.prevent="showCardDetail(card)"
              >
                <div
                  v-if="card.id !== editCardOfSet.id"
                  class="fs-16 fw-700 ellipsis"
                  style="width: 220px"
                >
                  {{ card.sparkTitle === "" ? "UNTITLED" : card.sparkTitle }}
                </div>
                <div v-else class="fs-16 fw-700 ellipsis" style="width: 220px">
                  {{
                    editCardOfSet.sparkTitle === ""
                      ? "UNTITLED"
                      : editCardOfSet.sparkTitle
                  }}
                  <span v-if="createNewCardStatus" class="opa-03 ml-12"
                    >{{ $t("sparks.Draft") }}</span
                  >
                </div>
                <div class="ml-auto fs-12">{{ index + 1 }}</div>
              </div>
            </draggable>
            <div class="px-6" v-if="setSelectedForEdit.type == 'custom'">
              <div
                class="card-create flex-center px-24 fs-16 fw-700 mt-15 cursor-pointer"
                @click.prevent="createNewCard"
              >
                + {{ $t("sparks.Create_a_New_Card") }}
              </div>
            </div>
          </div>
          <div
            id="editCard"
            class="bg-F8F8F8 py-40 px-32"
            style="height: 750px"
          >
            <div class="fs-16 fw-700 mt-24 mb-8">{{ $t("sparks.Spark_Title") }}</div>
            <div v-if="setSelectedForEdit.type !== 'happily'">
              <el-input
                :placeholder="$t('sparks.Title')"
                v-model="editCardOfSet.sparkTitle"
                :value="editCardOfSet.sparkTitle.toUpperCase()"
                @change="forceUppercase(editCardOfSet.sparkTitle)"
                @keyup.native="forceUppercase(editCardOfSet.sparkTitle)"
                :class="{ 'validate-input': validateEditCardOfSet.sparkTitle }"
                :disabled="
                  editCardOfSet.id && setSelectedForEdit.type == 'custom'
                    ? !true
                    : !false
                "
              ></el-input>
              <div
                v-if="validateEditCardOfSet.sparkTitle"
                class="validate-worming"
              >
                <div class="text">{{ $t("sparks.Please_input_Spark_Title") }}</div>
              </div>
            </div>
            <div class="preview-title fs-18 ellipsis" v-else>
              {{ editCardOfSet.sparkTitle }}
            </div>
            <div class="fs-16 fw-700 mt-16">{{ $t("sparks.Spark_Icon") }}</div>
            <div class="mt-8">
              <div class="flex">
                <div
                  @click="selectNewSparkIcon(item, editCardOfSet.id && setSelectedForEdit.type == 'custom')"
                  v-for="item in sparkIconList" :key="item.name"
                  style="height: 24px;"
                  class="p-3 bg-FFFFFF bd-r-4 m-auto spark-icon"
                  :class="`${ item.name == editCardOfSet.spark_type.name ? 'icon-selected' : ''} ${editCardOfSet.id && setSelectedForEdit.type == 'custom' ? 'cursor-pointer' : ''}`"
                >
                  <img
                      :src="item.image"
                      alt="spark icon"
                      style="height: 24px; width: 24px"
                    />
                </div>
              </div>
            </div>
            <div class="fs-16 fw-700 mt-16">{{ $t("sparks.Spark_Content_English") }}</div>
            <div class="mt-8 thin-scrollbar" style="height: 200px">
              <vue-editor
                v-if="setSelectedForEdit.type !== 'happily'"
                :disabled="
                  editCardOfSet.id && setSelectedForEdit.type == 'custom'
                    ? !true
                    : !false
                "
                v-model="editCardOfSet.contentEN"
                :editorToolbar="customToolbar"
              ></vue-editor>
              <div
                class="preview-content"
                v-else
                v-html="editCardOfSet.contentEN"
              ></div>
            </div>
            <div class="fs-16 fw-700 mt-16">{{ $t("sparks.Spark_Content_Thai") }}</div>
            <div class="mt-8 thin-scrollbar font-kanit" style="height: 200px">
              <vue-editor
                v-if="setSelectedForEdit.type !== 'happily'"
                :disabled="
                  editCardOfSet.id && setSelectedForEdit.type == 'custom'
                    ? !true
                    : !false
                "
                v-model="editCardOfSet.contentTH"
                :editorToolbar="customToolbar"
              ></vue-editor>
              <div
                class="preview-content font-kanit"
                v-else
                v-html="editCardOfSet.contentTH"
              ></div>
            </div>
            <div
              class="mt-32"
              v-if="setSelectedForEdit.type == 'custom' && editCardOfSet.id"
            >
              <el-button
                class="btn-add"
                style="padding-left: 32px; padding-right: 32px"
                @click.prevent="saveNewCard"
                >{{ $t("sparks.SAVE_SPARK") }}</el-button
              >
              <el-button
                v-if="createNewCardStatus"
                class="btn-gray"
                style="padding-left: 32px; padding-right: 32px"
                @click.prevent="cancelCard"
                >{{ $t("sparks.CANCEL") }}</el-button
              >
              <el-button
                v-else
                class="btn-red"
                @click.prevent="deleteCard"
                style="padding-left: 32px; padding-right: 32px"
                >{{ $t("sparks.DELETE") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { VueEditor } from "vue2-editor";
import format from 'date-fns/format'

export default {
  components: {
    draggable,
    VueEditor,
  },
  created() {
    this.$store.dispatch("sparks/getSparkHappily",this.user);
    this.$store.dispatch("sparks/getSparkCustom",this.user);
    this.$store.dispatch("sparks/getSparkType");
  },
  data() {
    return {
      customToolbar: ["bold", "italic", "strike", "underline"],
      editSetStatus: false,
      dialogCreateSetStatus: false,
      dialogEditSetStatus: false,
      newSet: {
        // Modal crete new set
        setName: "",
        position: null,
        id: false,
        customSet: false,
        happilySet: null,
        permissions: "Everyone",
      },
      validateNewSet: {
        // Modal crete new set
        setName: false,
        position: false,
        happilySet: null,
        customSet: null,
        permissions: false,
      },
      setSelectedForEdit: {
        // Modal edit card
        setName: "",
        happilySet: 0,
        customSet: 0,
        permissions: ["Everyone"],
        type: "custom",
        id: null,
        cardList: [],
      },
      setBeforeEdit: {
        setName: "",
        position: null,
        cardList: [],
      },
      createNewCardStatus: false,
      editCardOfSet: {
        // Modal edit card (Rigth)
        sparkTitle: "",
        id: false,
        contentTH:
          '<p style="color:#000000; font-family:Lato; font-size:16px"></p>',
        contentEN:
          '<p style="color:#000000; font-family:Lato; font-size:16px"></p>',
        spark_type:{name:'Bubble 1',id:'-LfcUmRWEAOWbzzm9OsG'}
      },
      validateEditCardOfSet: {
        // Modal edit card (Rigth)
        sparkTitle: false,
        contentTH: false,
        contentEN: false,
      },
      permissionsList: [
        {
          key: "Everyone",
          label: "Everyone",
        },
      ],
      oldCurrentMoveSet: false,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    // setShowingList() {
    //   return this.$store.getters["sparks/sparkHappily"];
    // },
    setShowingList:{
       get() {
            return this.$store.getters["sparks/sparkHappily"];
        },
        set(value) {
            this.$store.commit('sparks/setSparkHappily', value)
        }
    },
    sparkHappilyloading() {
      return this.$store.getters["sparks/sparkHappilyloading"];
    },
    sparkCustomSatus() {
      return this.$store.getters["sparks/sparkStatus"];
    },
    customList() {
      return this.$store.getters["sparks/sparkCustom"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    cardId() {
      return this.$store.getters["sparks/cardId"];
    },
    customClass() {
      return this.$store.getters["sparks/customClass"];
    },
    sparkIconList(){
      return this.$store.getters["sparks/sparkType"];
    }
  },
  methods: {
    setSparkList() {
      this.$store.dispatch("sparks/getSparkHappily",this.user);
      this.$store.dispatch("sparks/getSparkCustom",this.user);
    },
    setNumber(happilySet, customSet) {
      if (happilySet < 1 && customSet == 1) {
        return `Before Set 1`;
      } else if (customSet == 1) {
        return `After Set ${happilySet}`;
      } else if (customSet > 1) {
        for (let i = 0; i < this.customList.length; i++) {
          if (
            this.customList[i].customSet == customSet - 1 &&
            this.customList[i].happilySet == happilySet
          ) {
            return `After Set ${this.customList[i].name}`;
          }
        }
      } else {
        return "-";
      }
    },
    styleWidhtAndHeight(length) {
      let width = length * 6 > 17 ? 180 : 180 - length * 6;
      let height = length * 6 > 17 ? 112 : 112 - length * 6;
      return `width: ${width}px; height: ${height}px;`;
    },
    chooseRecipe(event, origin) {
      if (
        event.draggedContext.element.type &&
        event.draggedContext.element.type === "happily"
      ) {
        this.oldCurrentMoveSet = false;
        return false;
      } else {
        this.oldCurrentMoveSet =
          event.relatedContext.list[event.draggedContext.index + 1];
      }
    },
    async downPositionOfSet() {
      for (let i = 0; i < this.customList.length; i++) {
        if (
          this.customList[i].happilySet == this.oldCurrentMoveSet.happilySet &&
          this.customList[i].customSet >= this.oldCurrentMoveSet.customSet
        ) {
          this.customList[i].customSet = this.customList[i].customSet - 1;
          await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
          // console.log(
          //   "Update new positions of this Set - 8",
          //   this.customList[i]
          // ); // TODO: [API]Update position of this Set.
        }
      }
    },
    async updateSet(event) {
      const currentPosition = event.newIndex;
      
      const movedSet = this.setShowingList[currentPosition] || false;
      const beforeSet = this.setShowingList[currentPosition - 1] || false;

      await this.downPositionOfSet();
      if (beforeSet.type && beforeSet.type == "happily") {
        for (let i = 0; i < this.customList.length; i++) {
          if (
            this.customList[i].happilySet == beforeSet.happilySet &&
            this.customList[i].id !== movedSet.id
          ) {
            this.customList[i].customSet = this.customList[i].customSet + 1;
            this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
            // console.log(
            //   "Update new positions of this Set - 1",
            //   this.customList[i]
            // ); // TODO: [API]Update position of this Set.
          }
        }
        this.setShowingList[currentPosition].customSet = 1;
        this.setShowingList[currentPosition].happilySet = beforeSet.happilySet;
      } else if (beforeSet.type && beforeSet.type == "custom") {
        for (let i = 0; i < this.customList.length; i++) {
          if (
            this.customList[i].happilySet == beforeSet.happilySet &&
            this.customList[i].customSet > beforeSet.customSet
          ) {
            this.customList[i].customSet = this.customList[i].customSet + 1;
            await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
            // console.log(
            //   "Update new positions of this Set - 2",
            //   this.customList[i]
            // ); // TODO: [API]Update position of this Set.
          }
        }
        this.setShowingList[currentPosition].customSet =
          beforeSet.customSet + 1;
        this.setShowingList[currentPosition].happilySet = beforeSet.happilySet;
      } else if (beforeSet == false) {
        for (let i = 0; i < this.customList.length; i++) {
          if (this.customList[i].happilySet == 0) {
            this.customList[i].customSet = this.customList[i].customSet + 1;
            await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
          }
        }
        this.setShowingList[currentPosition].customSet = 1;
        this.setShowingList[currentPosition].happilySet = 0;
        await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.setShowingList[currentPosition]);
      }
      await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.setShowingList[currentPosition]);
    },
    showLableNewSet(set) {
      if (set.type == "happily") {
        return "After Set " + set.happilySet;
      } else {
        return "After Set " + set.name;
      }
    },
    alertNameSet() {
      if (this.sparkCustomSatus) {
        return this.$message({
          type: "error",
          message: "Set Name already exists.",
        });
      } else {
        return this.$message({
          type: "success",
          message: "A Spark Set has been successfully created.",
        });
      }
    },
    async createNewSet(update) {
      this.validateNewSet.setName = !this.$utils(
        "watchingTrim",
        this.newSet.setName
      );
      if (!this.validateNewSet.setName) {
        this.setSelectedForEdit.setName = this.newSet.setName;
        this.setSelectedForEdit.permissions = ["Everyone"];
        this.setSelectedForEdit.type = "custom";
        this.setSelectedForEdit.id = update.id || this.$utils("mockingID", 15); // Fix mockingID to UUID
        if (this.newSet.position == "#beforeSetOne") {
          this.setSelectedForEdit.happilySet = 0;
          this.setSelectedForEdit.customSet = 1;
          for (let i = 0; i < this.customList.length; i++) {
            if (this.customList[i].happilySet == 0) {
              this.customList[i].customSet = this.customList[i].customSet + 1;
               await this.$store.dispatch("sparks/checkSetName",{name:this.setSelectedForEdit.setName,user:this.user});
               if(!this.sparkCustomSatus){
                await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
               }
            }
          }
        } else {
          for (let i = 0; i < this.setShowingList.length; i++) {
            if (this.setShowingList[i].id == this.newSet.position ) {
              this.setSelectedForEdit.happilySet = this.setShowingList[i].happilySet;
              this.setSelectedForEdit.customSet =this.setShowingList[i].customSet + 1;
              for (let i2 = 0; i2 < this.customList.length; i2++) {
                if (
                  this.customList[i2].happilySet ==
                    this.setShowingList[i].happilySet &&
                  this.customList[i2].customSet >
                    this.setShowingList[i].customSet
                ) {
                  this.customList[i2].customSet =this.customList[i2].customSet + 1;
                    await this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i2]);
                }
              }
            }
          }
        }
        if (update.id!==undefined) {
          const cloneSet = {
            name: this.setSelectedForEdit.setName,
            permissions: this.setSelectedForEdit.permissions,
            type: this.setSelectedForEdit.type,
            happilySet: this.setSelectedForEdit.happilySet,
            customSet: this.setSelectedForEdit.customSet,
            id: this.setSelectedForEdit.id,
            cardList: this.setBeforeEdit.cardList,
          };
          // this.customList = this.customList.filter((obj) => {
          //   return obj.id !== this.newSet.id;
          // });
          //this.customList.push(cloneSet)
          
          if(this.setBeforeEdit.setName !== this.newSet.setName)
          {
            await this.$store.dispatch("sparks/checkSetName",{name:this.setSelectedForEdit.setName,user:this.user});
          }
          if (!this.sparkCustomSatus){
            await this.$store.dispatch("sparks/updateSparkCustom",cloneSet);
          }
          this.alertNameSet()
          this.clearSetSelected();
        } else {
          const newSet = {
            name: this.setSelectedForEdit.setName,
            permissions: this.setSelectedForEdit.permissions,
            //type: this.setSelectedForEdit.type,
            happilySet: this.setSelectedForEdit.happilySet,
            customSet: this.setSelectedForEdit.customSet,
            companyId:this.user.company,
            //id: this.setSelectedForEdit.setName,
            cardList: [],
          };
          await this.$store.dispatch("sparks/checkSetName", {name:newSet.name,user:this.user}).then(()=>{
            this.alertNameSet()
          });
          
          if(!this.sparkCustomSatus){
            await this.$store.dispatch("sparks/createSparkSetCustom", newSet).then(()=>{
              this.dialogEditSetStatus = true;
              this.setSparkList();
              if (!this.sparkCustomSatus) {
              this.clearCreateNewSet();
              this.clearSetSelected();
              }

            });
             
          }
        }
        // this.setSparkList();
        // if (!this.sparkCustomSatus) {
          
        //   this.clearCreateNewSet();
        //   this.clearSetSelected();
        // }
      }
    },
    async saveChangesSet() {
      if (
        this.newSet.position !== this.setBeforeEdit.position &&
        this.setBeforeEdit.setName !== this.newSet.setName
      ) {
        for (let i = 0; i < this.customList.length; i++) {
          if (this.customList[i].id == this.newSet.id) {
            this.oldCurrentMoveSet = {
              happilySet: this.customList[i].happilySet,
              customSet: this.customList[i].customSet,
            };
          }
        }
        await this.downPositionOfSet();
        this.createNewSet(this.newSet);
      } else if (this.newSet.position !== this.setBeforeEdit.position) {
        for (let i = 0; i < this.customList.length; i++) {
          if (this.customList[i].id == this.newSet.id) {
            this.oldCurrentMoveSet = {
              happilySet: this.customList[i].happilySet,
              customSet: this.customList[i].customSet,
            };
            
          }
        }
        await this.downPositionOfSet();
        this.createNewSet(this.newSet);
      } else if (this.setBeforeEdit.setName !== this.newSet.setName) {
        for (let i = 0; i < this.customList.length; i++) {
          if (this.customList[i].id == this.newSet.id) {
            this.customList[i].name = this.newSet.setName;
            await this.$store.dispatch(
              "sparks/updateSetNameSparkCustom",
              {data:this.customList[i],user:this.user}
            );
           this.alertNameSet()
            // console.log(
            //   "Update new positions of this set - 11",
            //   this.customList[i]
            // ); // TODO: [API]Update position of this Set. (User added new set on the font of all data)
          }
        }
        this.setSparkList();
      }
      if (!this.sparkCustomSatus) {
        this.clearCreateNewSet();
      }
    },
    deleteSparkSet() {
      const text = `This will delete '${this.newSet.setName}' set. Continue?`;
      this.$confirm(text, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          // this.customList = this.customList.filter((obj) => {
          //   return obj.id !== this.newSet.id;
          // });
          
          for (let i = 0; i < this.customList.length; i++) {
            if (
              this.customList[i].happilySet == this.newSet.happilySet &&
              this.customList[i].customSet > this.newSet.customSet
            ) {
              this.customList[i].customSet = this.customList[i].customSet - 1;

              this.$store.dispatch("sparks/updatePositionsSparkCustom",this.customList[i]);
              // console.log(
              //   "Update new positions of this Set - 10",
              //   this.customList[i]
              // ); // TODO: [API]Update position of this Set. (User added new set on the font of all data)
            }
          }
          this.$store.dispatch("sparks/deleteSparkCustom",this.newSet);
          this.setSparkList();
          this.clearCreateNewSet();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    clearCreateNewSet() {
      this.newSet.setName = "";
      this.newSet.position = null;
      this.newSet.id = false;
      this.newSet.customSet = 0;
      this.newSet.happilySet = 0;
      this.newSet.permissions = "Everyone";
      this.validateNewSet.setName = false;
      this.validateNewSet.position = false;
      this.validateNewSet.permissions = false;
      this.dialogCreateSetStatus = false;
      this.editSetStatus = false;
      this.setBeforeEdit.setName = "";
      this.setBeforeEdit.cardList = [];
      this.setBeforeEdit.position = null;
    },
    clossEditSet() {
      if (this.createNewCardStatus) {
        const text = `This will discard the 'Draft Card'. Continue?`;
        this.$confirm(text, "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        })
          .then(() => {
            this.deleteCardInCustomList();
            this.clearSetSelected();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Discard canceled",
            });
          });
      } else {
        this.clearSetSelected();
        this.clearCardOfSetSelected();
      }
    },
    clearSetSelected() {
      this.setSelectedForEdit.setName = "";
      this.setSelectedForEdit.happilySet = false;
      this.setSelectedForEdit.customSet = false;
      this.setSelectedForEdit.permissions = [];
      this.setSelectedForEdit.type = "happily";
      this.setSelectedForEdit.id = false;
      this.setSelectedForEdit.cardList = [];
      this.dialogEditSetStatus = false;
      

    },
    clearCardOfSetSelected() {
      this.editCardOfSet.sparkTitle = "";
      this.editCardOfSet.id = false;
      this.editCardOfSet.contentTH =
        '<p style="color:#000000; font-family:Lato; font-size:16px;"></p>';
      this.editCardOfSet.contentEN =
        '<p style="color:#000000; font-family:Lato; font-size:16px;"></p>';
      this.validateEditCardOfSet.sparkTitle = false;
      this.validateEditCardOfSet.contentTH = false;
      this.validateEditCardOfSet.contentEN = false;
      this.editCardOfSet.spark_type={name:'Bubble 1',id:'-LfcUmRWEAOWbzzm9OsG'}
    },
    createNewCard() {
      if (this.createNewCardStatus) {
        this.$confirm(
          "Are you sure you want to discard this card and create a new one?",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        )
          .then(() => {
            this.createNewCardStatus = false;
            this.setSelectedForEdit.cardList = this.setSelectedForEdit.cardList.filter(
              (obj) => {
                return obj.id !== this.editCardOfSet.id;
              }
            );
            this.createNewCard();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Discard canceled",
            });
          });
      } else {
        this.createNewCardStatus = true;
        this.clearCardOfSetSelected(); 
        const newID = this.$utils("mockingID", 16); // Fix mockingID to UUID
        this.editCardOfSet.id = newID;
        this.setSelectedForEdit.cardList.push({
          name: "",
          order:0,
          id:newID,
          set:this.setSelectedForEdit.id,
          content_th:
            '<p style="color:#00000; font-family:Lato; font-size:16px;"></p>',
          content_en:
            '<p style="color:#000000; font-family:Lato; font-size:16px;"></p>',
        });
      }
    },
    chooseRecipeCard(event, origin) {
      if (this.createNewCardStatus) {
        this.showAlertSaveOrCancel();
        return false;
      } else if (this.setSelectedForEdit.type == "happily") {
        return false;
      }
    },
    updateCradList(event) {
      if (this.createNewCardStatus) {
        this.showAlertSaveOrCancel();
      } else {
        for (let i = 0; i < this.customList.length; i++) {
          if (this.customList[i].id == this.setSelectedForEdit.id) {
            this.customList[i].cardList = this.setSelectedForEdit.cardList;
            for(let j = 0; j < this.setSelectedForEdit.cardList.length; j++)
            {
              const order={order:j+1}
              this.$store.dispatch("sparks/updateSpartCustomClass",{id:this.setSelectedForEdit.cardList[j].id,data:order});
            }
          }
        }
        this.setSparkList()
      }
    },
    async saveNewCard() {
      this.validateEditCardOfSet.sparkTitle = !this.$utils(
        "watchingTrim",
        this.editCardOfSet.sparkTitle
      );
      if (!this.validateEditCardOfSet.sparkTitle) {
        for (let i = 0; i < this.setSelectedForEdit.cardList.length; i++) {
          if (this.setSelectedForEdit.cardList[i].id == this.editCardOfSet.id) {
            this.setSelectedForEdit.cardList[i].name = this.editCardOfSet.sparkTitle;
            this.setSelectedForEdit.cardList[i].order=i+1;
            this.setSelectedForEdit.cardList[i].type=this.editCardOfSet.spark_type.id;
            this.setSelectedForEdit.cardList[i].content_th = this.contentSave(
              this.editCardOfSet.contentTH
            );
            this.setSelectedForEdit.cardList[i].content_en = this.contentSave(
              this.editCardOfSet.contentEN
            );
            this.setSelectedForEdit.cardList[i].createdate=format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            this.setSelectedForEdit.cardList[i].updated=format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            if(this.createNewCardStatus)
            {
              let data=this.setSelectedForEdit.cardList[i]
              delete data.id
              await this.$store.dispatch("sparks/createSparkCustomClass",data);
              this.$store.dispatch("sparks/getSparkHappily",this.user);
              this.$store.dispatch("sparks/getSparkCustom",this.user);
              this.setSelectedForEdit.cardList[i].id=this.cardId
              this.setSelectedForEdit.cardList[i].sparkTitle = this.editCardOfSet.sparkTitle;
              this.editCardOfSet.id=this.cardId
            }else{
              const content_enFixed = this.setSelectedForEdit.cardList[i].content_en.split('\"').join('"');
              const content_thFixed = this.setSelectedForEdit.cardList[i].content_th.split('\"').join('"');
              const changedata=
              {
                name:this.setSelectedForEdit.cardList[i].name,
                content_en: content_enFixed,
                content_th: content_thFixed,
                type:this.setSelectedForEdit.cardList[i].type,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm:ss')
              }

              await this.$store.dispatch("sparks/updateSpartCustomClass",{id:this.setSelectedForEdit.cardList[i].id,data:changedata});
              
              this.setSelectedForEdit.cardList[i].sparkTitle = this.editCardOfSet.sparkTitle;
             

            }
            
          }
        }
        this.createNewCardStatus = false;
        this.$message({
          message: "The Spark Set has been successfully updated.",
          type: "success",
        });
      }
    },
    showSetCard(set) {
      this.setSelectedForEdit.setName = set.name;
      this.setSelectedForEdit.happilySet = set.happilySet;
      this.setSelectedForEdit.customSet = set.customSet;
      this.setSelectedForEdit.permissions = set.permissions;
      this.setSelectedForEdit.type = set.type;
      this.setSelectedForEdit.id = set.id;
      this.setSelectedForEdit.cardList = set.cardList;
      this.dialogEditSetStatus = true;
      if(set.cardList.length>0){
        this.showCardDetail(set.cardList[0])
      }
      
    },
    showAlertSaveOrCancel() {
      const text = `Please 'SAVE SPARK' or 'CANCEL' before moving the card.`;
      this.$alert(text, "Oops!", {
        confirmButtonText: "OK",
      });
    },
    showCardDetail(card) {
      if (this.createNewCardStatus) {
        this.showAlertSaveOrCancel();
      } else {
        this.editCardOfSet.sparkTitle = card.sparkTitle;
        this.editCardOfSet.id = card.id;
        this.editCardOfSet.contentTH = this.contentShow(
          card.content_th !== undefined ? card.content_th : card.contentTH
        );
        this.editCardOfSet.contentEN = this.contentShow(
          card.content_en !== undefined ? card.content_en : card.contentEH
        );
        var data = _.find(this.sparkIconList, function(value){
          return value != null && value.id == card.type;
        });
        
        this.editCardOfSet.spark_type=data==undefined?'':data
      }
    },
    cancelCard() {
      this.createNewCardStatus = false;
      this.validateEditCardOfSet.sparkTitle = false;
      this.setSelectedForEdit.cardList = this.setSelectedForEdit.cardList.filter(
        (obj) => {
          return obj.id !== this.editCardOfSet.id;
        }
      );
      this.clearCardOfSetSelected();
    },
    deleteCard() {
      const test = `This will delete '${this.editCardOfSet.sparkTitle}' card. Continue?`;
      this.$confirm(test, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.deleteCardInCustomList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    deleteCardInCustomList() {
      this.createNewCardStatus = false;
      this.setSelectedForEdit.cardList = this.setSelectedForEdit.cardList.filter(
        (obj) => {
          return obj.id !== this.editCardOfSet.id;
        }
      );
      for (let i = 0; i < this.customList.length; i++) {
        if (this.customList[i].id == this.setSelectedForEdit.id) {
          this.customList[i].cardList = this.customList[i].cardList.filter(
            (obj) => {
              return obj.id !== this.editCardOfSet.id;
            }
          );
        }
      }
     this.$store.dispatch("sparks/deleteSparkCustomClass",this.editCardOfSet);
     this.setSparkList() 
      this.clearCardOfSetSelected();
      // console.log(
      //   "Delete Card [cardList - changed])!",
      //   this.setSelectedForEdit
      // ); // TODO: [API]Saving card list changed
    },
    contentShow(text) {
      if (text) {
        const removeTagP = text.split('<p style="color: #ffffff; font-family:Lato; font-size:13px;">').join("");
        const _reomoveTagP=removeTagP.split('<p style=\" color:#ffffff; font-family:Lato; font-size:13px;\">').join("");
        const removeTagPClose = _reomoveTagP.split('</p">').join("");
        const fixColor = removeTagPClose.split("color: #ffffff;").join("color:#000000;");
        const _fixColor = fixColor.split("color:#ffffff;").join("color:#000000;");
        const fixTagP = _fixColor.split("<span ").join("<p ");
        const fixTagP2 = fixTagP.split("<span>").join("<p>");
        const fixTagClose = fixTagP2.split("</span>").join("</p>");
        const fixFontSize = fixTagClose.split("13px;").join("16px;");
        return fixFontSize;
      } else {
        return '<p style="color: #ffffff; font-family:Lato; font-size:13px;"><span></span></p>';
      }
    },
    contentSave(text) {
      if (text) {
        const fixColor = text.split("color:#000000;").join("color: #ffffff;");
        const fixTagBr = fixColor.split("<br />").join("</p><p>");
        const fixTagP = fixTagBr.split("<p ").join("<span ");
        const fixTagP2 = fixTagP.split("<p>").join("<span>");
        const fixTagClose = fixTagP2.split("</p>").join("</span>");
        const fixFontSize = fixTagClose.split("13px;").join("font-size:16px;");
        return '<p style=" color:#ffffff; font-family:Lato; font-size:13px;">' +
          fixFontSize + '</p>';
      } else {
        return '<p style=" color:#ffffff; font-family:Lato; font-size:13px;"><span></span></p>';
      }
    },
    editSet(set) {
      //console.log("set",set)
      if(set.happilySet==0&&set.customSet==1)
      {
        this.newSet.position="#beforeSetOne"
      }else{
        this.newSet.position = this.setShowingList.find((obj) => {
        return (
          obj.happilySet === set.happilySet &&
          obj.customSet === set.customSet - 1
        );
      }).id;
      
      }
      
      this.newSet.setName = set.setName;
      this.newSet.id = set.id;
      this.newSet.customSet = set.customSet;
      this.newSet.happilySet = set.happilySet;
      this.newSet.permissions = "Everyone"; // The future need to fix this default permission.(Can add more then one)
      this.setBeforeEdit.setName = set.setName;
      this.setBeforeEdit.cardList = set.cardList;
      this.setBeforeEdit.position = this.newSet.position;
      this.editSetStatus = true;
      this.dialogCreateSetStatus = true;
      // setTimeout(() => {
      //   this.clearSetSelected();
      // }, 1000);
      
    },
    selectNewSparkIcon(newIcon, edit) {
      if (edit) {
        this.editCardOfSet.spark_type = newIcon;
      }
    },
    forceUppercase(wording) {
      this.editCardOfSet.sparkTitle = wording.toUpperCase(); 
    }
  },
};
</script>

<style lang="scss" scoped>
.grid-2-create-set {
  display: grid;
  grid-template-columns: 400px auto;
}
.create-set {
  padding: 35px 31px;
  border: 1px solid #ccc;
  background-color: #f7f7f7;
  border-radius: 9px;
  transition: 0.4s;
  &:hover {
    background-color: #f3f3f3;
  }
}
.set-spark {
  position: relative;
  width: 180px;
  height: 112px;
}
.set-spark-mock {
  position: relative;
  width: 300px;
  height: 160px;
}
.line-llink-new-set {
  height: 40px;
  width: 0px;
  border: 1px dashed #000;
  opacity: 0.2;
  margin-left: 12px;
}
.card {
  padding: 16px 12px 12px;
  border-radius: 9px;
  box-shadow: 0 1px 4px #00000029;
  width: calc(180px - (12px + 12px));
  height: calc(100px - (16px + 12px));
}
.card.card-mock {
  width: calc(300px - (12px + 12px));
  height: calc(160px - (16px + 12px));
}
.card.one,
.card.two,
.card.three {
  position: absolute;
}
.card.one {
  top: 0;
  left: 0;
}
.card.two {
  top: 6px;
  left: 6px;
}
.card.three {
  top: 12px;
  left: 12px;
}
.card.happily {
  background-color: white;
}
.card.custom {
  background-color: #f3f0f7;
}
.card-permissions {
  width: fit-content;
  max-width: 90px;
  border-radius: 3px;
  padding: 4px 8px;
  font-weight: 900;
  font-size: 12px;
  background-color: #00000025;
  color: #000000;
  opacity: 0.7;
}
.width-select {
  width: 100%;
}
.skeleton-title,
.skeleton-content {
  background-color: #000;
  border-radius: 3px;
  height: 32px;
}
.skeleton-title {
  opacity: 0.3;
  width: 235px;
  margin-bottom: 11px;
}
.skeleton-content {
  opacity: 0.1;
  width: 100px;
}
.edit-text {
  font-size: 14px;
  font-weight: 700;
  border: 1px dashed #00000030;
  padding-bottom: 1px;
  border-width: 0 0 1px 0;
}
.card-list,
.card-create {
  border-radius: 9px;
  height: 60px;
}
.card-list {
  border: 1px solid #ccc;
  box-shadow: 0 1px 8px #00000029;
  transition: 0.2s;
  &:hover {
    background-color: #fcfcfc;
  }
}
.card-selected {
  border: 1px solid #6c30cc;
}
.card-create {
  border: 1px solid #ccc;
  background-color: #f7f7f7;
  transition: 0.2s;
  &:hover {
    background-color: #f3f3f3;
  }
}
.quillWrapper {
  height: 200px;
}
.ql-toolbar {
  height: 32px;
  padding: 0 0;
}
.preview-content {
  background-color: #fff;
  min-height: calc(200px - 16px * 2);
  padding: 16px 24px;
  word-break: break-word;
}
.preview-title {
  background-color: #fff;
  height: calc(46px - 12px * 2);
  padding: 12px 24px;
}
</style>

<style lang="scss">
#editCard {
  .quillWrapper {
    height: 200px;
  }
  .ql-toolbar {
    height: 32px;
    padding: 0 0;
  }
  .ql-container {
    background-color: #fff;
    border-width: 0;
    height: calc(200px - 32px);
  }
  .ql-editor {
    min-height: calc(200px - 32px);
    height: calc(200px - 32px);
  }
  .ql-toolbar {
    background-color: #00000008;
    border-width: 0;
  }
  .quillWrapper .ql-snow.ql-toolbar button svg {
    width: 20px;
    height: 20px;
  }
  .ql-snow.ql-toolbar button {
    margin: 2px 5px 0;
  }
  .spark-icon {
    border: 1px solid #ffffff;
  }
  .icon-selected {
    border-color: #6C30CC;
    box-shadow: 0 1px 8px #00000029;
  }
}
</style>